import React, { FC, useState } from 'react';
import { isEmpty } from 'lodash';
import { ChoiceGroup, ChoiceGroupItem } from '@fiverr-private/forms';
import { Container } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { useCollapsibleItems } from '../../../hooks/useCollapsibleItems';
import { ITEM_ALL_ID } from '../../ServicesAndSkills/consts';
import { ServiceOrSkillItem } from '../types';

interface CollapsibleTagsProps {
    items: ServiceOrSkillItem[];
    initialVisibleItems?: number;
    onChange: (id?: string | null) => void;
}

const INITIAL_VISIBLE_ITEMS = 8;

export const CollapsibleTags: FC<CollapsibleTagsProps> = ({
    items,
    onChange,
    initialVisibleItems = INITIAL_VISIBLE_ITEMS,
}) => {
    const { visibleItems, collapsedItems, isShowingMore, showCollapsedItems } = useCollapsibleItems({
        items,
        initialVisibleItems,
    });

    const [groupValue, setGroupValue] = useState<string | null>(visibleItems[0].id);

    const handleChange = (id: string | null) => {
        setGroupValue(id);
        onChange(id);
    };

    return (
        <Container
            display={{
                default: 'none',
                md: 'flex',
            }}
        >
            <ChoiceGroup multiple={false} value={groupValue} onChange={handleChange}>
                {visibleItems.map((item) => (
                    <ChoiceGroupItem key={item.id} value={item.id}>
                        {`${item.name} ${item.count && item.id !== ITEM_ALL_ID ? `(${item.count})` : ''}`}
                    </ChoiceGroupItem>
                ))}
                {!isEmpty(collapsedItems) &&
                    (isShowingMore ? (
                        collapsedItems.map((item) => (
                            <ChoiceGroupItem key={item.id} value={item.id}>
                                {`${item.name} ${item.count ? `(${item.count})` : ''}`}
                            </ChoiceGroupItem>
                        ))
                    ) : (
                        <Box as="button" onClick={showCollapsedItems} cursor="pointer">
                            <Text fontWeight="semibold" color="bodyPrimary" decoration="underline" size="b_sm">
                                <I18n
                                    k={`${
                                        isShowingMore
                                            ? 'seller_page_perseus.services_tags.show_less'
                                            : 'seller_page_perseus.services_tags.show_more'
                                    }`}
                                />
                            </Text>
                        </Box>
                    ))}
            </ChoiceGroup>
        </Container>
    );
};
